import { render, staticRenderFns } from "./thread-text.vue?vue&type=template&id=d7d4d292&scoped=true&"
import script from "./thread-text.vue?vue&type=script&lang=js&"
export * from "./thread-text.vue?vue&type=script&lang=js&"
import style0 from "./thread-text.vue?vue&type=style&index=0&id=d7d4d292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d4d292",
  null
  
)

component.options.__file = "thread-text.vue"
export default component.exports